// extracted by mini-css-extract-plugin
export default {"stripe-form-wrapper":"payment_stripe-form-wrapper__J2AYx","title":"payment_title__Xr2LO"};